module.exports = __webpack_public_path__ + "static/customer-management.4938bcc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/apps/customer-management.png
// module id = 122
// module chunks = 35783957827783 68530290604204 153456355441848